export default "__VITE_ASSET__Cfykc_eq__"